import React, { useState } from 'react';
import { AppBar, Toolbar, IconButton, Box, ListItem, Typography } from '@mui/material';
import { styled } from '@mui/system';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { BlurBackground } from '../utils/theme';
import { ReactComponent as CloseIcon } from '../assets/close.svg';
import FoodLogo from '../assets/food-logo.png';
import MenuLogo from '../assets/hamburger-menu.png';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../configs/supabase';
import { routingPath } from '../utils/path';
import { GradientText } from '../utils/theme';
import { useCustomer } from '../features/hooks';

const MenuBox = styled(Box)<{ open: boolean }>(({ open }) => ({
  position: 'fixed',
  top: '-10px',
  right: open ? '-10px' : '-220px',
  width: '200px',
  height: '500px',
  backgroundColor: 'white',
  boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.4)',
  zIndex: 1300,
  borderRadius: '8px',
  padding: '16px',
  transition: 'right 0.2s ease-in-out', // トランジションを追加
}));

const StyledListItem = styled(ListItem)(({ theme }) => ({
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
  },
  padding: '8px 16px',
  borderRadius: '4px',
}));

const Header = () => {
  const [menuOpen, setMenuOpen] = useState<boolean>(false);
  const navigate = useNavigate();
  const { customer, loading: customerLoading } = useCustomer();

  const toggleMenu = () => { setMenuOpen(!menuOpen) };

  const logout = async () => {
    const { error } = await supabase.auth.signOut();
    if (error) console.error("ログアウトでエラーが発生しました");
    sessionStorage.clear();
    navigate(routingPath.login);
    return;
  }

  return (
    <>
    <AppBar position="fixed"
      sx={{
        backgroundColor: 'white',
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.4)'
      }}
    >
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: { xs: 'flex-start', sm: 'center' } }}>
          <Box 
            sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} 
            onClick={() => navigate(routingPath.auth.orderList)} // クリック時の処理
          >
            <img src={FoodLogo} alt="Food Logo" style={{ marginRight: '8px', width: '36px', height: '36px' }} />
            <GradientText style={{ fontSize: 24, marginTop: 10 }}>たのメシ.com</GradientText>
            {process.env.REACT_APP_ENVIRONMENT === 'LOCAL' && <GradientText style={{ fontSize: 12, marginTop: 10, marginLeft: 5 }}> - 開発用 - </GradientText>}
            {process.env.REACT_APP_ENVIRONMENT === 'STAGING' && <GradientText style={{ fontSize: 12, marginTop: 10, marginLeft: 5 }}> - ステージング - </GradientText>}
            {process.env.REACT_APP_ENVIRONMENT === 'NAKANO' && <GradientText style={{ fontSize: 12, marginTop: 10, marginLeft: 5 }}> - 中野外食 - </GradientText>}
          </Box>
          {!customerLoading && 
            <GradientText sx={{ fontSize: { xs: 14, sm: 24 }, marginTop: { xs: 0.1, sm: 1 }, marginLeft: { xs: 0, sm: 30 }, marginBottom: { xs: 2, sm: 0 } }}>{customer?.name}</GradientText>
          }
        </Box>
        <IconButton color="inherit" aria-label="menu" onClick={toggleMenu}>
          <img src={MenuLogo} alt='Menu logo' style={{ width: '24px', height: '24px' }} />
        </IconButton>
      </Toolbar>
    </AppBar>
    <Box sx={{ height: '18px' }} />
      {menuOpen && <BlurBackground onClick={toggleMenu} />}
      <MenuBox open={menuOpen}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }} >
          <IconButton onClick={toggleMenu} >
            <CloseIcon style={{ width: '24px', height: '24px' }}/>
          </IconButton>
        </Box>
        <Box>
          <StyledListItem key={'order-list'} onClick={() => { navigate(routingPath.auth.orderList); toggleMenu(); }}>
            <Typography variant="body1" sx={{ textAlign: 'left', fontWeight: 'bold', color: 'black' }}>
              {'発注'}
            </Typography>
          </StyledListItem>
          <StyledListItem key={'order-history'} onClick={() => { navigate(routingPath.auth.orderHistory); toggleMenu(); }}>
            <Typography variant="body1" sx={{ textAlign: 'left', fontWeight: 'bold', color: 'black' }}>
              {'発注履歴'}
            </Typography>
          </StyledListItem>
          <StyledListItem key={'delivery'} onClick={() => { navigate(routingPath.auth.delivery); toggleMenu(); }}>
            <Typography variant="body1" sx={{ textAlign: 'left', fontWeight: 'bold', color: 'black' }}>
              {'納品書'}
            </Typography>
          </StyledListItem>
          <StyledListItem 
            key={'manual'} 
            onClick={() => window.open('https://docs.google.com/presentation/d/1RIzz3wmVkkaebBR1UR8IbOXbRLDZU2kGXNEfLuxyfd0', '_blank')}
          >
            <Typography variant="body1" sx={{ textAlign: 'left', fontWeight: 'bold', color: 'black', display: 'flex', alignItems: 'center' }}>
              {'操作マニュアル'}<OpenInNewIcon/>
            </Typography>
          </StyledListItem>
          <StyledListItem key={'logout'} onClick={() => { logout(); toggleMenu(); }}>
            <Typography variant="body1" sx={{ textAlign: 'left', fontWeight: 'bold', color: 'black' }}>
              {'ログアウト'}
            </Typography>
          </StyledListItem>
        </Box>
      </MenuBox>
    </>
  );
};

export default Header;
